import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { parseTime } from "@/utils/util.js";
import dateRange from "@/components/newdaterange/index";
import { getErpRequestPriceList, syncErpRequestPrice, syncRequestPriceStatus } from "@/services/order/inquiry";
import { getSellerOptions } from "@/services/order/orderList";
import { toThousandslsFilter } from "@/filters";
import i18nInquiry from "./i18n-inquiry";
import i18nOrderList from "../i18n-orderList";
export default {
  name: "inquiryList",
  i18n: {
    messages: {
      CN: _objectSpread(_objectSpread({}, i18nInquiry.messages.CN), i18nOrderList.messages.CN),
      JP: _objectSpread(_objectSpread({}, i18nInquiry.messages.JP), i18nOrderList.messages.JP)
    }
  },
  components: {
    dateRange: dateRange
  },
  data: function data() {
    return {
      sellerList: [],
      queryParam: {
        page: 1,
        size: 20,
        condition: {}
      },
      tableLoading: false,
      tableData: [],
      total: 0,
      // 支付方式
      payMethodList: [{
        id: 1,
        name: this.$t("orderList.payMethod1")
      }, {
        id: 0,
        name: this.$t("orderList.payMethod2")
      }, {
        id: 2,
        name: this.$t("orderList.payMethod3")
      }],
      // 货运方式
      deliveryMethodList: [{
        id: 0,
        name: this.$t("orderList.deliveryMethod1")
      }, {
        id: 1,
        name: this.$t("orderList.deliveryMethod3")
      }, {
        id: 2,
        name: this.$t("orderList.deliveryMethod2")
      }],
      rightCurrencySymbol: localStorage.rightCurrencySymbol,
      leftCurrencySymbol: localStorage.leftCurrencySymbol,
      syncLoading: false // 同步见绩书 loading
    };
  },
  computed: {
    columns: function columns() {
      return [
      // 询价编号
      {
        title: this.$t("inquiryList.quoteNo"),
        dataIndex: "askPriceNo",
        width: 150,
        scopedSlots: {
          customRender: "askPriceNo"
        }
      },
      // 得意先情报
      {
        title: this.$t("inquiryList.erpCustomerName"),
        dataIndex: "erpCustomerName",
        width: 150,
        scopedSlots: {
          customRender: "erpCustomerName"
        }
      },
      // 担当者
      {
        title: this.$t("inquiryList.sellerName"),
        dataIndex: "sellerName",
        width: 100
      }, {
        //订单金额（含税）/支付方式
        // title: this.$t('orderList.ColTotalAmount'),
        dataIndex: "totalAmount",
        key: "totalAmount",
        width: 100,
        scopedSlots: {
          title: "totalAmountTitle",
          customRender: "totalAmount"
        },
        align: "right"
      },
      // // 询价状态
      // {
      //     title: this.$t('inquiryList.status'),
      //     dataIndex: 'status',
      //     width: 150,
      //     scopedSlots: {
      //         customRender: 'status',
      //     },
      // },
      // 询价时间
      {
        title: this.$t("inquiryList.quoteTime"),
        dataIndex: "orderDate",
        width: 150
      }, {
        title: this.$t("inquiryList.sendVersion"),
        dataIndex: "editno",
        width: 150
      },
      // 操作
      {
        title: this.$t("inquiryList.action"),
        dataIndex: "action",
        width: 150,
        scopedSlots: {
          customRender: "action"
        }
      }];
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.getData();
    getSellerOptions({
      scene: 3
    }).then(function (res) {
      if (res.data.code == 200) {
        _this.sellerList = res.data.data.map(function (item) {
          return {
            value: item.sellerCode,
            label: item.sellerName
          };
        });
      }
    });
  },
  methods: {
    syncErpRequestPriceFuc: function syncErpRequestPriceFuc() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var resOrder, resErpOrder;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this2.syncLoading = true;
              _context.p = 1;
              _context.n = 2;
              return syncErpRequestPrice();
            case 2:
              resOrder = _context.v;
              if (resOrder.data.code == 200) {
                _this2.$message.success(_this2.$t('public.updateSuccessfully'));
                _this2.getData();
              }
              _context.n = 3;
              return syncRequestPriceStatus();
            case 3:
              resErpOrder = _context.v;
            case 4:
              _context.p = 4;
              _this2.syncLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1,, 4, 5]]);
      }))();
    },
    toThousandslsFilter: toThousandslsFilter,
    getData: function getData() {
      var _this3 = this;
      this.tableLoading = true;
      var newParam = _.cloneDeep(this.queryParam);
      newParam.condition.deliveryWays = this.queryParam.condition.deliveryWays && this.queryParam.condition.deliveryWays.join(",");
      newParam.condition.sellerCode = this.queryParam.condition.sellerCode && this.queryParam.condition.sellerCode.join(",");
      getErpRequestPriceList(newParam).then(function (res) {
        if (res.data.code == 200) {
          _this3.tableData = res.data.data.list;
          _this3.total = res.data.data.totalNum;
        }
      }).finally(function () {
        _this3.tableLoading = false;
      });
    },
    handleDateChange: function handleDateChange(dateRange) {
      //console.log(typeof(dateRange.endDateClone),typeof(dateRange.startDateClone))
      if (dateRange.startDateClone != undefined) {
        if (_typeof(dateRange.startDateClone) == "object") {
          this.queryParam.condition.startOrderDate = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.condition.startOrderDate = dateRange.startDateClone;
        }
      } else {
        this.queryParam.condition.startOrderDate = "";
      }
      if (dateRange.endDateClone != undefined) {
        if (_typeof(dateRange.endDateClone) == "object") {
          this.queryParam.condition.endOrderDate = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
        } else {
          this.queryParam.condition.endOrderDate = dateRange.endDateClone;
        }
      } else {
        this.queryParam.condition.endOrderDate = "";
      }
    },
    handleClickQueryButton: function handleClickQueryButton() {
      this.queryParam.page = 1;
      this.getData();
    },
    hangeTableChange: function hangeTableChange(_ref) {
      var current = _ref.current,
        pageSize = _ref.pageSize;
      this.queryParam.page = current;
      this.queryParam.size = pageSize;
      this.getData();
    }
  }
};